import { createSlice } from "@reduxjs/toolkit";

const initialState = {}

export const rentSetupSlice = createSlice({
    name: "rentSetup",
    initialState,
    reducers: {
        setRentSetupSlice: (state, action) => {
            state.rentSetup = action.payload
        },
    },

});

export const { setRentSetupSlice } = rentSetupSlice.actions;
export default rentSetupSlice.reducer;